var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Model/createTreeModel.ts";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import { combine } from 'effector';
import { treeSort } from "../../helpers";
import { findEntityOrAssembly, findParent, generateName, itemFormRef$, setNewItem } from "../Model";
export function createTreeModel(_ref) {
  var tree$ = _ref.tree$,
      explorerTitle = _ref.explorerTitle,
      categoriesOnTop = _ref.categoriesOnTop;
  var root$ = combine({
    ɔ: [{
      itemFormRef: itemFormRef$,
      data: tree$
    }, function (_ref2) {
      var itemFormRef = _ref2.itemFormRef,
          data = _ref2.data;
      var rootNode = {
        type: 'Root',
        id: 'root',
        title: explorerTitle,
        children: categoriesOnTop ? treeSort({
          data: data,
          itemKey: 'type',
          priorityItemKeyValues: ['Category']
        }) : data,
        parentNode: null
      };
      var tree = [rootNode];

      if (itemFormRef) {
        switch (itemFormRef.type) {
          case 'Creating':
            {
              var itemType = itemFormRef.itemType,
                  parentCategoryId = itemFormRef.parentCategoryId;
              return setNewItem({
                root: tree,
                newNode: {
                  type: 'NewItem',
                  itemType: itemType,
                  parentCategoryId: parentCategoryId
                }
              });
            }

          case 'Copying':
            {
              var itemId = itemFormRef.itemId,
                  _itemType = itemFormRef.itemType,
                  _parentCategoryId = itemFormRef.parentCategoryId;

              if (_itemType === 'Category') {
                return tree;
              }

              var entity = findEntityOrAssembly({
                tree: tree,
                itemId: itemId,
                itemType: _itemType
              });

              if (!entity) {
                return tree;
              }

              var parentNode = findParent({
                tree: tree,
                parentCategoryId: _parentCategoryId
              });

              if (!parentNode) {
                return tree;
              }

              var sameLevelEntityNames = parentNode.children.filter(function (node) {
                return node.type === 'Entity';
              }).map(function (node) {
                return node.title;
              });
              return setNewItem({
                root: tree,
                newNode: {
                  type: 'NewCopy',
                  itemType: _itemType,
                  itemId: itemId,
                  parentCategoryId: _parentCategoryId,
                  originalName: entity.title,
                  version: entity.version,
                  defaultName: generateName(entity.title, sameLevelEntityNames)
                }
              });
            }
        }
      }

      return tree;
    }],
    config: {
      name: "root$",
      sid: "z0up5c"
    }
  });
  return {
    root$: root$
  };
}